<template>
	<div class="form-container">
		<div class="form-title-sub">(유)하이모 온라인 통합회원 서비스</div>
		<h2 class="form-title">회원 가입 완료</h2>

		<p class="form-desc-head">
			<span class="form-desc-head__underline"
				>하이모의 가족이 되신걸 축하 드립니다!</span
			>
		</p>

		<p class="form-desc">
			하이모는 최고의 기술력과 끊임없는 연구개발을<br />
			바탕으로 행복한 삶을 향한, 행복한 세상을<br />
			열어드리고자 합니다.<br />
			고객의 웃음은 곧 하이모의 웃음입니다.<br />
			언제나 정성을 다하는 서비스로
			<strong class="bold italic">{{ userName }}</strong
			>님께<br />
			보답하겠습니다.
		</p>

		<div class="form-group form-button">
			<Btn @click="onClickLogin" color="primary" x-large block>로그인</Btn>
		</div>
	</div>
</template>

<script>
import Btn from '@/components/common/Btn';

export default {
	components: {
		Btn,
	},
	computed: {
		userName() {
			return this.$store.state.signupStore.userName;
		},
	},
	methods: {
		onClickLogin() {
			// 회원가입 스토어 정보 삭제
			this.$store.commit('signupStore/resetState');

			// 로그인 페이지 이동
			this.$router.push({ name: 'login' });
		},
	},
};
</script>
